(() => {
  if (customElements.get('tb-blog-alignment')) return;
  class BlogAlignment extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.events = new AbortController();
      const schedule = () => this.schedule();
      this.resize = new ResizeObserver(entries => {
        const width = entries[0]?.contentRect.width;
        if (width !== this.width) { this.width = width; this.schedule(); }
      });
      this.resize.observe(this);
      this.mutations = new MutationObserver(schedule);
      this.mutations.observe(this, { childList: true, characterData: true, subtree: true });
      document.fonts?.addEventListener('loadingdone', schedule, { signal: this.events.signal });
      document.fonts?.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }
    schedule() {
      this.dataset.aligned = 'false';
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.align());
    }
    align() {
      if (!this.isConnected || !this.getBoundingClientRect().width) return;
      this.classList.add('is-measuring');
      try {
        for (const [selector, property, minimumLines] of [
          ['.tb-blog-card__date', '--tb-blog-date-height', 1],
          ['.tb-blog-card__title', '--tb-blog-title-height', 3],
          ['.tb-blog-card__excerpt', '--tb-blog-excerpt-height', 3],
        ]) {
          const elements = [...this.querySelectorAll(selector)].filter(e => e.getClientRects().length);
          let height = 0;
          for (const element of elements) {
            const style = getComputedStyle(element);
            const line = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5;
            const natural = element.getBoundingClientRect().height;
            const lines = Math.max(minimumLines, Math.ceil((natural - .1) / line));
            height = Math.max(height, lines * line);
          }
          this.style.setProperty(property, `${Math.ceil(height)}px`);
        }
      } finally {
        this.classList.remove('is-measuring');
      }
      this.dataset.alignedWidth = String(this.getBoundingClientRect().width);
      this.dataset.aligned = 'true';
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resize?.disconnect();
      this.mutations?.disconnect();
      this.events?.abort();
      this.width = null;
    }
  }
  customElements.define('tb-blog-alignment', BlogAlignment);
})();
